import { Injectable } from '@angular/core';

import { EngagementApiService } from '@frontend/promo-utils';
import { NavigationService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

@Injectable()
export class PromoContentLoaderService {
    constructor(
        private navigation: NavigationService,
        private api: EngagementApiService,
    ) {}

    getPromoRenderedContentForCurrentPage(): Observable<any> {
        // eslint:disable-next-line:typedef
        let requestUrl = this.navigation.location.absUrl();
        if (this.isPathToGetEngagementTool(requestUrl)) {
            requestUrl = requestUrl.replace('/promo/ep/', '/promo/engagement/');
        }
        requestUrl = requestUrl.replace('/promo/', '/promo/api/content/');

        return this.api.get(requestUrl, null, { resolveWithFullResponse: true });
    }

    private isPathToGetEngagementTool(path: string) {
        // getting index from where to remove the language code
        // eslint:disable-next-line:typedef
        return path.includes('/promo/ep/');
    }
}
